/* eslint-disable array-callback-return */
import { APP_PDC_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { MacroCategoriesTitles } from "../../../constants/document_categories";

export const categoryConstants = {
  GET_NEW_TREE_CATEGORY_START: "GET_NEW_TREE_CATEGORY_START",
  GET_NEW_TREE_CATEGORY_SUCCESS: "GET_NEW_TREE_CATEGORY_SUCCESS",
  GET_NEW_TREE_CATEGORY_ERROR: "GET_NEW_TREE_CATEGORY_ERROR"
};

function flatObject(obj) {
  let arrayDocType = [];
  Object.keys(obj).map((keyMacro) => {
    let macroTitle = keyMacro;
    if (MacroCategoriesTitles[keyMacro.toLowerCase()]) {
      macroTitle = MacroCategoriesTitles[keyMacro.toLowerCase()];
    }
    Object.keys(obj[keyMacro]).map((keyMicro) => {
      let microTitle = keyMicro;
      Object.keys(obj[keyMacro][keyMicro]).map((keyType) => {
        arrayDocType.push({
          id: obj[keyMacro][keyMicro][keyType].id,
          title: obj[keyMacro][keyMicro][keyType].title,
          macro: macroTitle,
          micro: microTitle
        });
        return arrayDocType;
      });
      return arrayDocType;
    });
    return arrayDocType;
  });

  arrayDocType.sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0));

  return arrayDocType;
}

export function getTreeCategoryNew() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const companyId = main.clientIdSelected;

    let request = {
      method: "get",
      url: `${APP_PDC_URL}/categories/${companyId}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise((resolve, reject) => {
      dispatch({
        type: categoryConstants.GET_NEW_TREE_CATEGORY_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: categoryConstants.GET_NEW_TREE_CATEGORY_SUCCESS,
              payload: flatObject(result.data)
            });
          } else {
            dispatch({
              type: categoryConstants.GET_NEW_TREE_CATEGORY_ERROR,
              error: result
            });
          }
        })
        .catch((response) => {
          dispatch({
            type: categoryConstants.GET_NEW_TREE_CATEGORY_ERROR,
            error: response
          });
        });
    });
  };
}
